import React, { use, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setPage, setMaxPages, setSorting, setCheckedItem, toggleAddModal, toggleEditModal } from '../../store/sportsTabSlice.js';
import {
  getHeaders,
  headerWidths,
  tabsConfig,
  buttonsConfig,
  leftSideConfig,
  rightSideConfig,
  empty,
  sortButtonsConfig,
} from './sportsTableConfig.js';
import { fetchSports } from './sportsTableService.js';
import Table from '../../components/list2/table';
import Pagination from '../../components/components/pagination/pagination.jsx';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import LineWithButtons from '../../components/components/line_with_buttons/lineWithButtons.jsx';
import UniversalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';

import AddSport from './addSport.jsx';
import EditSportModal from './editSport.jsx';
import './Sports.css';

function Sports() {

  const dispatch = useDispatch(); 
  const activeTab = useSelector((state) => state.sports.activeUsersTab);
  const totalPages = useSelector((state) => state.sports.maxPages);
  const currentPage = useSelector((state) => state.sports.currentPage);
  const sortBy = useSelector((state) => state.sports.sortBy);
  const sortDirection = useSelector((state) => state.sports.sortDirection);
  const checkedItems = useSelector((state) => state.sports.checkedItems);
  const addModalOpen = useSelector((state) => state.sports.addModalOpen);
  const editModalOpen = useSelector((state) => state.sports.editModalOpen);
  const keyword = useSelector((state) => state.sports.keyword);
  const searchValue = useSelector((state) => state.sports.searchValue);
  const sortSortListEndpoint = useSelector((state) => state.sports.sortSortListEndpoint);

  const needRefresh = useSelector((state) => state.sports.needRefresh);

  const [rowsSports, setRowsSports] = useState([]);
  const sortArrowColorActive = '#060606';
  const sortArrowColorInactive = '#06060650';

    // Funkcja otwierająca modal (Redux Action)
    const handleToggleAddModal = () => {
      dispatch(toggleAddModal());
    };
    const handleToggleEditModal = () => {
      dispatch(toggleEditModal());
    };

  useEffect(() => {
    fetchSports(sortBy, sortDirection, keyword, currentPage, dispatch, setMaxPages, setRowsSports, checkedItems);

  }, [currentPage, sortBy, sortDirection, checkedItems, needRefresh, keyword]);

  const headers = getHeaders(
    sortBy,
    sortDirection,
    dispatch,
    setSorting,
    sortArrowColorActive,
    sortArrowColorInactive,
    rowsSports,
    checkedItems);

    const paginationProps = {
      reduxSelector: (state) => state.sports.currentPage,
      reduxAction: setPage,
      totalPages: totalPages,
      maxVisibleButtons: 5,
    };
    
    const rightSideConfig2 = [
      {
        component: Pagination, // Komponent do wyrenderowania
        props: paginationProps, // Właściwości przekazywane do komponentu
      },
    ];

  return (
    <div>
      {addModalOpen && <AddSport />}
      {editModalOpen && 
        <EditSportModal />}      
      <Menu />
      <Content>
        <LineWithButtons tabs={tabsConfig(activeTab, dispatch)} buttons={buttonsConfig(handleToggleAddModal)} />
      
        <div className="table-container">          
            <UniversalLineWithComponents leftSide={sortButtonsConfig(dispatch, sortSortListEndpoint)} rightSide={rightSideConfig(searchValue, dispatch)} />
            <Table
              headers={headers}
              rowsClass='row-sports'
              cellClass='cell-sports'
              rows={rowsSports}
              columnWidths={headerWidths}
              idViewing={true}
              idArrayId={1}
              cellClass2='cell-center'
              cellClass2ConditionList={[1, 4, 5, 6]} />
            <UniversalLineWithComponents leftSide={leftSideConfig(dispatch)} rightSide={rightSideConfig2} />
        </div>
      </Content>
    </div>
  );
}

export default Sports;